import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

export class ZIDXAccountSites implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSitesContainer";
    }
    render(){
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
    }
}
